/**
 * ¿Se llega al servidor ahora mismo?
 *
 * Versión mínima de `useOffline` para las pantallas que sólo necesitan saber si
 * conviene ofrecer una acción que sin servidor no puede funcionar — el portal
 * del mecánico, el check list, las reparaciones. `useOffline` arranca la
 * vigilancia y sigue además la cola de envíos y la última sincronización; acá
 * alcanza con suscribirse al estado que esa vigilancia ya publica.
 *
 * El estado sale de `offline/conexion`, que **sondea al servidor** en vez de
 * creerle a `navigator.onLine`. Ver ahí el porqué: con datos móviles activos y
 * el servidor inalcanzable ese flag devuelve `true` igual, y una pantalla que
 * necesita servidor se abriría para morir a la primera petición.
 *
 * `VERIFICANDO` cuenta como que sí, igual que en `hayServidor()`: mientras no
 * se sepa, lo correcto es dejar intentar. Bloquear durante el primer sondeo
 * haría parpadear "necesita conexión" cada vez que se abre la app con señal,
 * que es la mentira opuesta y se paga igual de cara en confianza.
 */

import { useEffect, useState } from 'react';
import { estadoConexion, hayServidor, suscribirseAConexion } from '../offline/conexion';

/** Texto único para explicar por qué una acción no está disponible. */
export function mensajeSinServidor(accion) {
  return `No se puede ${accion} en este momento: hace falta conexión con el `
    + 'servidor y ahora no está disponible. Probá de nuevo cuando vuelva la señal — lo '
    + 'que ya cargaste sin conexión no se pierde.';
}

export function useHayServidor() {
  const [conexion, setConexion] = useState(estadoConexion);

  useEffect(() => {
    // Se relee al montar: entre el `useState` inicial y este efecto puede haber
    // terminado un sondeo, y el suscriptor sólo avisa de los cambios futuros.
    setConexion(estadoConexion());
    return suscribirseAConexion(setConexion);
  }, []);

  return { conexion, hayServidor: hayServidor() };
}

export default useHayServidor;
